import { Injectable } from '@angular/core';
import { ProjectInfo, SystemInfo, SystemTypes } from '@frontend-site/shared/data';
import { LastPageGroup, RememberLastPageProperties } from './last-page/entities/last-page';
import { LastPagePersistenceFacade } from './last-page/last-page-persistence.facade';

@Injectable({ providedIn: 'root' })
export class PersistenceFacade {
    constructor(private readonly lastPagePersistence: LastPagePersistenceFacade) {}

    rememberPage(rememberMe: RememberLastPageProperties | boolean, path: string): void {
        this.lastPagePersistence.setLastPage(rememberMe, path);
    }

    getLastPage(fallback: string = '/project'): string {
        return this.lastPagePersistence.getLastPage(fallback);
    }

    getGroupedLastPageVisited(group: LastPageGroup): string | null | undefined {
        return this.lastPagePersistence.getGroupedLastPageVisited(group);
    }

    getLastSystem(): SystemInfo | null | undefined {
        return this.lastPagePersistence.getLastSystem();
    }
    getLastSystemByType(systemType: SystemTypes): SystemInfo | null | undefined {
        return this.lastPagePersistence.getLastSystemByType(systemType);
    }
    getLastProjectInfo(): ProjectInfo | null {
        return this.lastPagePersistence.getLastProjectInfo();
    }
}
